// extracted by mini-css-extract-plugin
module.exports = {"game":"Game_game__1Fx4K","credit":"Game_credit__1IpTN"};